import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import { FreshworksHelper } from "app/helpers/freshworksHelper";
import { UserType } from "app/types/userType";
import isPublicView from "app/utils/publicViewUtils";
import { SessionHelper } from "../../helpers/sessionHelper";

import AccountVerificationHeader from "./components/AccountVerificationHeader/AccountVerificationHeader";

import "./AccountVerificationScreenDesktop.scss";
import "./AccountVerificationScreenMobile.scss";
import VerifyYourIdentity from "./components/VerifyYourIdentity/VerifyYourIdentity";

type Props = {
  user: UserType;
};

const AccountVerificationScreen: React.FC<Props> = ({ user }) => {
  const history = useHistory();

  useEffect(() => {
    FreshworksHelper.showWidget();
    return () => {
      if (!isPublicView()) {
        FreshworksHelper.hideWidget();
      }
    };
  }, []);

  return (
    <div
      className={`account-verification ${
        SessionHelper.isAsianSessionView() ? "account-verification-asian" : ""
      }`}
    >
      <AccountVerificationHeader history={history} />
      <VerifyYourIdentity />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.userModel.user,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountVerificationScreen);
